import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { badgeConfig, tokens } from '../../constants';
import { fitContentWidth } from '../../utils';
export var getSelectedState = (isSelected, type) => {
  var selectedState = isSelected ? 'selected' : 'none';
  selectedState = type === 'multi' && isSelected ? 'multiSelected' : selectedState;
  return selectedState;
};
export var getBadgeStyles = (props, _state) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var size = props.size,
    showPrefixIcon = props.showPrefixIcon,
    isSelected = props.isSelected,
    type = props.type,
    showPostfixIcon = props.showPostfixIcon,
    showNotifier = props.showNotifier,
    multitextLabel = props.multitextLabel;
  var selectedState = getSelectedState(isSelected, type);
  var controlState = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.states) === null || _b === void 0 ? void 0 : _b[selectedState]) === null || _c === void 0 ? void 0 : _c.controlStates;
  var backgroundColor = (_d = controlState === null || controlState === void 0 ? void 0 : controlState[_state]) === null || _d === void 0 ? void 0 : _d.backgroundColor;
  var textColor = (_e = controlState === null || controlState === void 0 ? void 0 : controlState[_state]) === null || _e === void 0 ? void 0 : _e.textColor;
  var borderColor = (_f = controlState === null || controlState === void 0 ? void 0 : controlState[_state]) === null || _f === void 0 ? void 0 : _f.borderColor;
  var isHoverState = _state === 'hover';
  var hoverStyle = {
    borderColor: borderColor
  };
  var borderRadius = tokens.borderRadius.BORDER_RADIUS_32;
  var marginLeft = {
    marginLeft: tokens.spacing.SPACING_4
  };
  var marginRight = {
    marginRight: tokens.spacing.SPACING_4
  };
  var iconBorderRadius = tokens.borderRadius.BORDER_RADIUS_100;
  var configSize = (_h = (_g = props === null || props === void 0 ? void 0 : props.config) === null || _g === void 0 ? void 0 : _g.size) === null || _h === void 0 ? void 0 : _h[size];
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 0,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor
    }, fitContentWidth()), {
      borderWidth: 1,
      borderColor: backgroundColor,
      borderRadius
    }), isHoverState && hoverStyle), {
      paddingHorizontal: (_j = tokens.spacing) === null || _j === void 0 ? void 0 : _j[configSize === null || configSize === void 0 ? void 0 : configSize.paddingHorizontal],
      height: configSize === null || configSize === void 0 ? void 0 : configSize.badgeSize
    }),
    label: Object.assign(Object.assign({}, !multitextLabel && {
      color: textColor
    }), {
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }),
    iconContainer: Object.assign(Object.assign({
      overflow: 'hidden'
    }, selectedState === 'multiSelected' && marginLeft), {
      borderRadius: iconBorderRadius
    }),
    prefixIconContainer: Object.assign({}, showPrefixIcon && marginRight),
    marginLeft: Object.assign({}, (showPostfixIcon || showNotifier) && marginLeft)
  });
};
export var getBadgeFontTypes = size => {
  var labelTypes = {
    sm: 'body-single-line-xxs',
    md: 'body-single-line-sm',
    lg: 'body-single-line-md'
  };
  return labelTypes === null || labelTypes === void 0 ? void 0 : labelTypes[size];
};
export var getBadgeProps = (props, context) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(badgeConfig === null || badgeConfig === void 0 ? void 0 : badgeConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.badge) === null || _a === void 0 ? void 0 : _a[theme]);
  var type = (props === null || props === void 0 ? void 0 : props.type) || (configProps === null || configProps === void 0 ? void 0 : configProps.type);
  var selectedState = getSelectedState(props === null || props === void 0 ? void 0 : props.isSelected, type);
  var controlStates = (_d = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _b === void 0 ? void 0 : _b.states) === null || _c === void 0 ? void 0 : _c[selectedState]) === null || _d === void 0 ? void 0 : _d.controlStates;
  var controlState = props.disabled && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  var size = (props === null || props === void 0 ? void 0 : props.size) || (configProps === null || configProps === void 0 ? void 0 : configProps.size);
  var prefixIconPropsConfig = {
    width: (_e = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _e === void 0 ? void 0 : _e.size[size].prefixIconSize,
    height: (_f = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _f === void 0 ? void 0 : _f.size[size].prefixIconSize,
    color: (_g = controlStates === null || controlStates === void 0 ? void 0 : controlStates[controlState]) === null || _g === void 0 ? void 0 : _g.prefixIconColor
  };
  var postfixIconPropsConfig = {
    width: (_h = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _h === void 0 ? void 0 : _h.size[size].postfixIconSize,
    height: (_j = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _j === void 0 ? void 0 : _j.size[size].postfixIconSize,
    color: (_k = controlStates === null || controlStates === void 0 ? void 0 : controlStates[controlState]) === null || _k === void 0 ? void 0 : _k.postfixIconColor
  };
  var prefixIconProps = Object.assign(Object.assign({}, prefixIconPropsConfig), props === null || props === void 0 ? void 0 : props.prefixIconProps);
  var postfixIconProps = Object.assign(Object.assign({}, postfixIconPropsConfig), props === null || props === void 0 ? void 0 : props.postfixIconProps);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    prefixIconProps,
    postfixIconProps,
    controlState
  });
};